<script setup lang="ts">
  defineProps({
    SeatTotalTableData: { type: Array, default: () => [] },
  });
  
  const getSeatNum = (number: number) => {
    // 如果number大于1000000，则返回number/1000000，并保留2位小数
    if (number >= 1000000) {
      return (number / 1000000).toFixed(2) + "M";
    }
    return number.toLocaleString();
  }

  const getSeatPercent = (value?: number, total?: number) => {
    const safeValue = Number(value ?? 0);
    const safeTotal = Number(total ?? 0);
    if (safeTotal <= 0) return '0.0%';
    const percent = (safeValue / safeTotal) * 100;
    const clamped = Math.max(0, Math.min(100, percent));
    return `${clamped.toFixed(1)}%`;
  };
</script>
<template>
  <div style="margin-top: 5px;">
    <div class="detail-row">
      <span class="detail-label">午前</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: getSeatPercent(SeatTotalTableData[0]?.morningSeatTotalNo, SeatTotalTableData[0]?.seatTotalNo),
          background: 'var(--accent-blue)',
        }"></div>
      </div>
      <span class="detail-value">{{ getSeatNum(SeatTotalTableData[0]?.morningSeatTotalNo ?? 0) }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">午後</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: getSeatPercent(SeatTotalTableData[0]?.afternoonSeatTotalNo, SeatTotalTableData[0]?.seatTotalNo),
          background: 'var(--brand-color)',
        }"></div>
      </div>
      <span class="detail-value">{{ getSeatNum(SeatTotalTableData[0]?.afternoonSeatTotalNo ?? 0) }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">夜</span>
      <div class="detail-bar-container">
        <div class="detail-bar" :style="{
          width: getSeatPercent(SeatTotalTableData[0]?.nightSeatTotalNo, SeatTotalTableData[0]?.seatTotalNo),
          background: 'var(--accent-purple)',
        }"></div>
      </div>
      <span class="detail-value">{{ getSeatNum(SeatTotalTableData[0]?.nightSeatTotalNo ?? 0) }}</span>
    </div>
  </div>
</template>